import React from 'react';
import { Link } from 'react-router-dom'; // Added this import
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-layout-section">
      <div className="footer-layout-container">

        {/* --- Column 1: College Info & Preview --- */}
        <div className="footer-layout-column footer-layout-info">
          <h3 className="footer-layout-title">SK COLLEGE</h3>
          <p className="footer-layout-description">
            A leading institution committed to nation-building through quality
            education, innovation, and inclusive learning since 2021.
          </p>
          <p className="footer-layout-description">
            Empowering students with knowledge, skills, and values to succeed
            in a rapidly evolving world.
          </p>
        </div>

        {/* --- Column 2: Quick Links --- */}
        <div className="footer-layout-column footer-layout-links">
          <h4 className="footer-layout-subtitle">Quick Links</h4>

          <ul className="footer-layout-links-grid">
            <li><Link to="/"><span>➜</span> Home</Link></li>
            <li><Link to="/about"><span>➜</span> About Us</Link></li>
            <li><Link to="/courses"><span>➜</span> Courses</Link></li>
            <li><Link to="/gallery"><span>➜</span> Gallery</Link></li>
            <li><Link to="/achievements"><span>➜</span> Achievements</Link></li>
            <li><Link to="/news"><span>➜</span> News</Link></li>
            <li><Link to="/video-gallery"><span>➜</span> Video Gallery</Link></li>
            <li><Link to="/contact"><span>➜</span> Contact</Link></li>
          </ul>
        </div>

        {/* --- Column 3: Location / Contact --- */}
        <div className="footer-layout-column footer-layout-contact">
          <h4 className="footer-layout-subtitle">Our Location</h4>

          <p className="footer-layout-contact-item">
            <span className="footer-layout-icon">📍</span>
            SK College Campus, Mankalao
            <br />
            Distt. Jodhpur, Rajasthan - 342305
          </p>

          <p className="footer-layout-contact-item">
            <span className="footer-layout-icon">📞</span>
            +91-8003566524
          </p>

          <p className="footer-layout-contact-item">
            <span className="footer-layout-icon">📧</span>
            dr.manaklao@gmail.com
          </p>
        </div>

        {/* --- Column 4: Social Media --- */}
        <div className="footer-layout-column footer-layout-social">
          <h4 className="footer-layout-subtitle">Follow Us</h4>

          <div className="footer-layout-social-icons">
            <a href="/" className="footer-social facebook" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="/" className="footer-social twitter" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="/" className="footer-social instagram" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="/" className="footer-social linkedin" aria-label="LinkedIn">
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>
        </div>

      </div>

      {/* --- Bottom Bar --- */}
      {/* --- Bottom Bar --- */}
<div className="footer-layout-bottom">
  <div className="footer-layout-bottom-container">
    <p className="footer-layout-copyright">
      © {currentYear} SK COLLEGE. All Rights Reserved.
    </p>

    <p className="footer-layout-developer">
      Developed & Designed With <span className="footer-heart">❤️</span> By 
      <span className="footer-company"> Dheer Software Solutions</span>
    </p>
  </div>
</div>

    </footer>
  );
}

export default Footer;